import { ApprovalStatus } from './types';

// HWM-22633: the status-filter key space. Two VIRTUAL keys
// (MEDICAL_CHECK_SCHEDULED / MEDICAL_CHECK_MISSED) are translated by the
// backend `VIRTUAL_STATUS_FILTER_KEYS` into (MEDICAL_CHECK, sub_status).
// INSURANCE_VALIDATION is omitted (backend collapses it into INITIAL_INTEREST).
export type StatusFilterKey = ApprovalStatus | 'MEDICAL_CHECK_SCHEDULED' | 'MEDICAL_CHECK_MISSED';

// Every selectable key. Also the allow-list used to sanitize stale/unknown
// values (e.g. the retired QUALIFIED) out of the persisted/URL param.
export const ALL_STATUS_FILTER_KEYS: StatusFilterKey[] = [
    'INITIAL_INTEREST',
    'MEDICAL_CHECK_SCHEDULED',
    'MEDICAL_CHECK_MISSED',
    'PENDING_ENROLLMENT',
    'APPROVED',
    'REJECTED',
    'EXPIRED'
];
